//
// Module for the Repayment Batch detail view
//
rs.module("content/participant/benefit/repayments/detail",

    [ "controls/components/event-banner" ],

    function (eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, ajaxUrls, registersGrid) {

            var form = $.js(jsSelectors.form);

            var isTrialHiddenInput = form.js(jsSelectors.isTrial);
            var detailsContainer = form.js(jsSelectors.detailsContainer);

            if (registersGrid) {

                registersGrid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {

                        eventBanner.removeAllMessages();

                        $.ajax({
                            url: ajaxUrls.getRepayRegisterDetail,
                            data: {
                                repayRegisterKey: registersGrid.selectedValues[0],
                                isTrialBatch: isTrialHiddenInput.val()
                            },
                            success: function (data) {
                                detailsContainer.html(data);
                            }
                        });
                    }

                    _executeSelectionChanged = true;
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);